import { ImgHTMLAttributes } from 'react';

import ClosedStoreAnimated from './assets/closed-store-animated.svg?url';
import WomanWaitingAnimated from './assets/woman-waiting-animated.svg?url';
import WomanWipAnimated from './assets/woman-wip-animated.svg?url';

const AnimatedIllustration = ({ name, className, size, ...props }: AnimatedIllustrationProps) => {
  const src = animatedIllustrationUrls[name];

  return <img alt={name} className={className} height={size} src={src} width={size} {...props} />;
};

type AnimatedIllustrationName = keyof typeof animatedIllustrationUrls;

type AnimatedIllustrationProps = {
  readonly name: AnimatedIllustrationName;
  readonly className?: string;
  readonly size?: number | string;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'name' | 'src' | 'alt'>;

const animatedIllustrationUrls = {
  ClosedStoreAnimated,
  WomanWaitingAnimated,
  WomanWipAnimated,
};

export { AnimatedIllustration, ClosedStoreAnimated, WomanWaitingAnimated, WomanWipAnimated };
export type { AnimatedIllustrationName, AnimatedIllustrationProps };
